import { GA_TRACKING_ID } from "@/lib/ga";

export type PlaywireAdStatus =
  | "provider_timeout"
  | "initial_filled"
  | "initial_empty"
  | "retry_filled"
  | "retry_empty";

export interface PlaywireAdTelemetry {
  status: PlaywireAdStatus;
  layout: string;
  selectorId: string;
  unitType: string;
  elapsedMs: number;
}

export function reportPlaywireAdTelemetry(event: PlaywireAdTelemetry) {
  if (typeof window === "undefined") return;

  const detail = {
    ad_provider: "playwire",
    ad_status: event.status,
    ad_layout: event.layout,
    ad_selector: event.selectorId,
    ad_unit: event.unitType,
    elapsed_ms: Math.max(0, Math.round(event.elapsedMs)),
    page_path: window.location.pathname,
  };

  window.dispatchEvent(
    new CustomEvent("chesshotel:playwire-ad-lifecycle", { detail }),
  );

  if (typeof window.gtag === "function") {
    window.gtag("event", "playwire_ad_lifecycle", {
      ...detail,
      send_to: GA_TRACKING_ID,
    });
  }
}
